import React, { useState, useEffect } from 'react'
import { Box, CircularProgress, Icon } from '@mui/material'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const AdxCircularLoad = ({ height }) => {
  const [showMessage, setShowMessage] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMessage(true)
    }, 15000)

    return () => clearTimeout(timer) // Cleanup the timer on component unmount
  }, [])

  return (
    <Box
      sx={{
        height: height,
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      {!showMessage ? (
        <CircularProgress sx={{ color: 'alternate' }} />
      ) : (
        <AdxEmptyStateV2
          icon={<Icon>signal_cellular_connected_no_internet_4_bar</Icon>}
          title="Uh Oh, Something Went Wrong"
          subtitle="Refresh the page or check your connection. If condition persists, something's probably happened on our end."
        />
      )}
    </Box>
  )
}

export default AdxCircularLoad
